import { resolveComponent as _resolveComponent, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-5afe8fda")

_pushScopeId("data-v-5afe8fda")
const _hoisted_1 = { class: "m-4 mb-0 lg:mx-auto max-w-4xl" }
const _hoisted_2 = { class: "mt-4 mx-4" }
const _hoisted_3 = { class: "space-y-0 mx-4 bp-font-text sm:x-auto flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center\n" }
const _hoisted_4 = { class: "flex flex-wrap justify-center" }
const _hoisted_5 = { class: "mt-4 w-auto" }
const _hoisted_6 = { class: "md:mx-4 w-full md:w-ad md:max-w-sm" }
const _hoisted_7 = { class: "justify-between w-full h-auto md:max-w-sm" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_search = _resolveComponent("search")
  const _component_Filter = _resolveComponent("Filter")
  const _component_DefaultSpinner = _resolveComponent("DefaultSpinner")
  const _component_default_image_layout = _resolveComponent("default-image-layout")
  const _component_default_ad = _resolveComponent("default-ad")

  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_search, {
        id: "search",
        "data-aos": "zoom-in-up",
        "data-aos-anchor": "#lightweightSearch",
        "search-placeholder": _ctx.$t('boostpack.BoostpackFeed.SearchPlaceholder'),
        onSearch: _ctx.searchBoostpackItems
      }, null, 8, ["search-placeholder", "onSearch"])
    ]),
    _createVNode("div", _hoisted_2, [
      _withDirectives(_createVNode(_component_Filter, null, null, 512), [
        [_vShow, false]
      ])
    ]),
    _createVNode(_component_DefaultSpinner, {
      id: "feedSpinner",
      "show-spinner": _ctx.isBoostpackFeedLoading(),
      "show-spinner-alternative-text": false,
      "data-aos": "zoom-in-up",
      "data-aos-anchor": "feedSpinner",
      class: "py-12",
      "spinner-size": "h-12 w-12"
    }, null, 8, ["show-spinner"]),
    _createVNode("div", _hoisted_3, [
      _createVNode("div", _hoisted_4, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.boostpackItems, (item, key) => {
          return (_openBlock(), _createBlock("div", {
            key: item,
            class: "space-y-4 bp-font-text flex-col sm:flex-row md:items-center md:flex flex-wrap justify-center items-center justify-center"
          }, [
            _createVNode("div", _hoisted_5, [
              _createVNode(_component_default_image_layout, {
                "alt-image-text": _ctx.getAltImageTextByTitleDescriptionAndCategory(item.data.title, item.data.description, item.category),
                "detail-image": item.media,
                "boostpack-reference": item.boostpackReference,
                item: item
              }, null, 8, ["alt-image-text", "detail-image", "boostpack-reference", "item"])
            ]),
            _withDirectives(_createVNode("div", _hoisted_6, [
              _createVNode("div", _hoisted_7, [
                _createVNode("div", null, [
                  _createVNode(_component_default_ad),
                  _createVNode(_component_default_ad)
                ])
              ])
            ], 512), [
              [_vShow, _ctx.isAdEnabled(key)]
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode("div", {
      ref: "intersectionTrigger",
      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.checkIfNewContentIsLoading && _ctx.checkIfNewContentIsLoading(...args)))
    }, [
      _createVNode(_component_DefaultSpinner, {
        "show-spinner": _ctx.boostpackMetaData && _ctx.boostpackMetaData.current_page < _ctx.boostpackMetaData.last_page,
        "show-spinner-alternative-text": false,
        "data-aos": "zoom-in-up",
        "data-aos-anchor": "feedSpinner",
        class: "py-12",
        "spinner-size": "h-12 w-12"
      }, null, 8, ["show-spinner"])
    ], 512)
  ]))
})